<template lang="pug">
  el-dialog(
    title="Support",
    v-if="dialogVisible",
    :visible.sync="dialogVisible",
    :before-close="handleClose",
  ).max-dialog-w-1000.support
    el-form(
      :model='signUp',
      status-icon,
      :rules="rules",
      ref="signUp",
      @submit.native.prevent="validateForm('signUp')"
    )
      .row
        el-form-item(prop='email').col-md-6.col-sm-6
          el-input(
            type="email",
            v-model='signUp.email',
            placeholder="Email*"
          )

        el-form-item(prop='firstName').col-md-6.col-sm-6
          el-input(
            type='text',
            v-model='signUp.firstName',
            auto-complete='off',
            placeholder='Name*'
          )

        el-form-item(prop='lastName').col-md-12
          el-input(
            type='textarea',
            v-model='signUp.text',
            auto-complete='off',
            placeholder='Support Text'
          )
      .ftr
        el-button.el-button--primary(
          @click="btnClicked"
        ) Send
        el-button(
          @click="handleClose"
        ) Close

</template>

<script>

import { mapActions } from 'vuex';

export default {
  name: 'SupportMail',
  props: {
    dialogVisible: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      rules: {
        email: [
          { required: true, message: 'Email address is required', trigger: 'blur' },
          { type: 'email', message: 'Please enter a valid Email address', trigger: 'blur' },
        ],
        firstName: {
          required: true,
          message: 'Name is required',
          trigger: 'blur',
        },
      },
      signUp: {
        email: null,
        firstName: null,
        text: null,
      },
    };
  },
  methods: {
    ...mapActions('users', [
      'sendSupportMail',
    ]),
    btnClicked() {
      // Send mail
      this.$refs.signUp.validate((valid) => {
        if (valid) {
          console.log(this.signUp);
          this.sendSupportMail(this.signUp);
          this.$message({
            message: 'Your message has been sent to support@spendhub.net.',
            type: 'success',
          });
          this.handleClose();
        }
      });
      return false;
    },
    handleClose() {
      this.$emit('handleParentClose');
    },
  },
};
</script>
